module.exports = __webpack_public_path__ + "0d7c22cd35978257e368f3236299c71b.svg";